










import { Vue, Component, Prop } from 'vue-property-decorator'
import { BlockElement, Block as BlockType } from '@/store/freestyle'
import Block from './block.vue'

@Component({
  components: {
    Block
  },
  filters: {
    normalize(item: BlockElement): BlockType {
      if (typeof item === 'string') {
        return { src: item }
      }
      return item
    }
  }
})
export default class extends Vue {
  @Prop({
    type: String,
    required: true
  })
  id: string

  @Prop({
    type: Array
  })
  elements: BlockElement[]
}
